const filterControlsOpenPopup = () => {
    const filterControlButtons = document.querySelectorAll('.Filters-popup-control');
    const popupWithFilters = document.querySelector('.Content__aside-popup.--Is-filters');

    if (popupWithFilters && filterControlButtons) {
        filterControlButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const popupIsVisible = popupWithFilters.classList.contains('--is-visible');

                if (popupIsVisible) {
                    popupWithFilters.classList.remove('--is-visible');
                    document.body.style.overflow = '';
                } else {
                    popupWithFilters.classList.add('--is-visible');
                    document.body.style.overflow = 'hidden';
                }
            });
        });
    }
};

export default filterControlsOpenPopup;
